import styled from 'styled-components';
import { darkerBackground, primaryBlue } from '../models/colors';

export const Spinner = styled('div')`
  width: 64px;
  height: 64px;
  margin: 64px 0;
  border-radius: 50%;
  border: 8px solid ${darkerBackground};
  border-top: 8px solid ${primaryBlue};
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
